import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 25px;
`;

export const LinkBlock = styled.div`
  background: #17ade3;
  display: flex;
  justify-content: center;
  margin-top: -50px;
`;

export const H2 = styled.h1`
  text-align: center;
  font-size: 16px;
  margin-top: 10px;
`;

export const Label = styled.div`
  font-size: 16px;
  min-width: 150px;
`;

export const TableBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;
export const MealsBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 10px auto;
`;

export const ProductNameBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto 20px;
`;

export const ButtonBlock = styled.div`
  width: 70%;
  display: flex;
  justify-content: center;
  margin: 20px auto 0;
`;
const activeClassName = 'active';

export const StyledLink = styled(NavLink).attrs({
  activeClassName: activeClassName,
})`
  display: block;
  height: 100%;
  padding: 0 10px;
  color: #ffffff;
  line-height: 50px;
  text-decoration: none;
  transition: all 0.3s;
  background: #17ade3;
  &:hover {
    background: #157aac;
    color: #ffffff;
  }
  @media (max-width: 345px) {
    font-size: 14px;
  }
  &.${activeClassName} {
    background: #157aac;
  }
`;

export const FooterBlock = styled.div`
  height: 50px;
`;

export const AllTagsBlock = styled.div`
  display: flex;
  justify-content: center;
  width: 70%;
  margin: 20px auto 0;
`;

export const AllTagBlock = styled.div`
  width: 100%;
  margin: 0 10px;
`;

export const TitleOfCbju = styled.div`
  display: flex;
  font-size: 12px;
  flex-direction: row;
  justify-content: space-between;
  height: 10px;
`;

export const RecipeBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 75%;
  margin: 20px auto 0;
`;

export const RecipeContentBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin-bottom: 5px;
`;

export const RecipeButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-left: 5px;
`;

export const RecipeListBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  flex-basis: 50%;
  align-items: center;
`;

export const RecipeDescription = styled.div`
  display: flex;
  width: 50%;
  justify-content: center;
`;

export const StepTitle = styled.p`
  margin-right: 2px;
  margin-left: 5px;
  width: 50px;
`;

export const UploadedPhoto = styled.p`
  color: gray;
`;

export const PreviewImage = styled.p`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  width: 30%;
`;

export const AddPhotoBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 80%;
  margin: 20px auto 0;
`;

export const Recipe = styled.div`
  margin-top: 10px;
`;

export const RecipenCookingTime = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 75%;
  margin: 0 auto;
`;

export const IsDraftCheckboxBlock = styled.div`
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateDishPage/CreateDishStyles.js